module.exports = __webpack_public_path__ + "img/bp_gift3.50781a54.png";